
////////////////////////////////////////////////////////
//
// header gnavi
//
////////////////////////////////////////////////////////

$(function() {
  $('.gnavi-list').hover(function() {
    $(this).find('.gnavi-cont').stop().fadeIn(200);
    $('.gnavi-bg').stop().fadeIn(200);
  }, function() {
    $(this).find('.gnavi-cont').stop().fadeOut(200);
    $('.gnavi-bg').stop().fadeOut(200);
  });
});
$(function() {
  $('.g-inner-list').hover(function() {
    $(this).find('.g-inner-cont').stop().fadeIn(200);
  }, function() {
    $(this).find('.g-inner-cont').stop().fadeOut(200);
  });
});

$(function() {
  $('.gnavi-list2').hover(function() {
    $(this).find('.gnavi-cont').stop().fadeIn(200);
    $('.gnavi-bg').stop().fadeIn(200);
  }, function() {
    $(this).find('.gnavi-cont').stop().fadeOut(200);
    $('.gnavi-bg').stop().fadeOut(200);
  });
});
$(function() {
  $('.g-inner-list').hover(function() {
    $(this).find('.g-inner-cont').stop().fadeIn(200);
  }, function() {
    $(this).find('.g-inner-cont').stop().fadeOut(200);
  });
});
$(function() {
  $('.g-inner-list2').hover(function() {
    $(this).find('.g-inner-cont2').stop().fadeIn(200);
  }, function() {
    $(this).find('.g-inner-cont2').stop().fadeOut(200);
  });
});

////////////////////////////////////////////////////////
//
// アコーディオン
//
////////////////////////////////////////////////////////

// センサー製品DLコンテンツ
$(function(){
  const btn = $(".btn_acdn_trgr");
  btn.click(function(){
    openFun($(this));
  });

  function openFun(btnTrigger){
    const btn = btnTrigger;
    const target = btn.parents('.btn_acdn').find('.btn_acdn_drwr');
    if(target.hasClass('open')){
      target.slideUp("fast").removeClass('open');
    }else{
      target.slideDown("fast").addClass('open');
    }
  }
});

// 製品ページフッターメニュー
$(function(){
  //$('.section').hide();
  $('.menu-sldtab-btn').on('click',function(){
    // クリックした要素の ID と違うクラス名のセクションを非表示
    $('.menu-sldtab-cont').not($('.'+$(this).attr('id'))).slideUp('fast');
    // クリックした要素の ID と同じクラスのセクションを表示
    $('.'+$(this).attr('id')).slideToggle('fast');
    // toggle にすると、同じボタンを 2 回押すと非表示になる
    // $('.'+$(this).attr('id')).toggle();
  });
});

$(function(){
  //$('.section').hide();
  $('.menu-sldtab-btn3').on('click',function(){
    // クリックした要素の ID と違うクラス名のセクションを非表示
    $('.menu-sldtab-cont3').not($('.'+$(this).attr('id'))).slideUp('fast');
    // クリックした要素の ID と同じクラスのセクションを表示
    $('.'+$(this).attr('id')).slideToggle('fast');
    // toggle にすると、同じボタンを 2 回押すと非表示になる
    // $('.'+$(this).attr('id')).toggle();
  });
});

////////////////////////////////////////////////////////
//
// スマホでタッチ時にhoverを有効に
//
////////////////////////////////////////////////////////

$( 'a, input[type="button"], input[type="submit"], button')
  .bind( 'touchstart', function(){
    $( this ).addClass( 'hover' );
}).bind( 'touchend', function(){
    $( this ).removeClass( 'hover' );
});

////////////////////////////////////////////////////////
//
//  問い合わせ結果ページ value 空タグ削除
//
////////////////////////////////////////////////////////

$(function(){
	$('.rtxt').each(function(){
		var txt = $(this).text();
		$(this).text(txt.replace(/,/g,""));
	});
  $('.rtxt_add1').each(function(){
		var txt = $(this).text();
		$(this).text(txt.replace(/,/g,"  /"));
	});
  $('.rtxt_add2').each(function(){
		var txt = $(this).text();
		$(this).text(txt.replace(/,/g,""));
	});
  // INPUTの空白、カンマを削除
  $('.rtxtval').each(function(){
    var txtval = $(this).val();
    $(this).val(txtval.replace(/,+ /g," "));
  });
});

////////////////////////////////////////////////////////
//
//  ボタン有効無効
//
////////////////////////////////////////////////////////

$(function() {
  $('#submitBtn').prop('disabled', true);

  $('#check').on('click', function() {
    if ( $(this).prop('checked') == false ) {
      $('#submitBtn').prop('disabled', true);
    } else {
      $('#submitBtn').prop('disabled', false);
    }
  });
});

////////////////////////////////////////////////////////
//
//  ダウンロード - 図面ソート
//
////////////////////////////////////////////////////////

$(function () {
  $('.search_box').change(function () {
    var select_val = $('.search_box option:selected').val();
    $.each($(".sizelist_dl tbody tr"), function (index, element) {
      if (select_val == "") {
        $(element).show();
        return true;
      }
      var row_text = $(element).text();
      if (row_text.indexOf(select_val) != -1) {
        $(element).show().fadeIn();
      } else {
        $(element).hide().fadeOut();
      }
    });
  });
});

////////////////////////////////////////////////////////
//
//  複数カテゴリ絞り込み
//
////////////////////////////////////////////////////////

//
// 「サイズ・型式で探す」絞り込み
//

var searchBox = '.search-box'; // 絞り込む項目を選択するエリア
var listItem = '.list_item';   // 絞り込み対象のアイテム
var hideClass = 'hide';     // 絞り込み対象外の場合に付与されるclass名

$(function() {
  // 絞り込み項目を変更した時
  $(document).on('change', searchBox, function() {
    search_filter();
  });
  
  // リストの絞り込みを行う
  function search_filter() {
    // 非表示状態を解除
    $(listItem).removeClass(hideClass);
    for (var i = 0; i < $(searchBox).length; i++) {
      var name = $(searchBox).eq(i).attr('name');
      // 選択されている項目を取得
      var searchData = get_selected_input_items(name);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if(searchData.length === 0 || searchData[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(listItem).length; j++) {
        // アイテムに設定している項目を取得
        var itemData = get_setting_values_in_item($(listItem).eq(j), name);
        // 絞り込み対象かどうかを調べる
        var check = array_match_check(itemData, searchData);
        if(!check) {
          $(listItem).eq(j).addClass(hideClass);
        }
      }
    }
  }
  function get_selected_input_items(name) {
    var searchData = [];
    $('select[name=' + name + '] option:selected').each(function() {
      searchData.push($(this).val());
    });
    return searchData;
  }
  function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if(!Array.isArray(itemData)) {
      itemData = [itemData];
    }
    return itemData;
  }
  function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
});

//
// 「Download」絞り込み
//

$(function() {
  // カテゴリ絞り込み
  $(document).ready(function(){
    $(".dl_cate").find('input[name=cate]').on("change", change_select1);
  });
  function change_select1(){
    const valueCate = $('.dl_cate').find('input[name=cate]:checked').attr("value");
    const lengthProdOpt = $(".dl_prod option").length;
    for (var i = 1; i < lengthProdOpt; i++) {
      const opt1 = $(".dl_prod option").eq(i);
      const cls1 = opt1.attr("class");
      if (valueCate == cls1){
          opt1.fadeIn('fast');
      } else if (valueCate == "") {
          opt1.fadeIn('fast');
      } else {
          opt1.fadeOut('fast');
      }
    }
    const lengthListOpt = $(".dl_table tr").length;
    for (var i = 0; i < lengthListOpt; i++) {
      const opt2 = $(".dl_table tr").eq(i);
      const cls2 = opt2.data("cate");
      if (valueCate == cls2){
          opt2.fadeIn('fast');
      } else if (valueCate == "") {
          opt2.fadeIn('fast');
      } else {
          opt2.fadeOut('fast');
      }
    }

  }
  // 連動プルダウン絞り込み
  const dlSearch = '.dl_box';
  const dlList = '.dl_list_item';

  $(document).on('change', dlSearch, function() {
    search_filter_dl();
  });
  function search_filter_dl() {
    $(dlList).fadeIn('fast');
    for (var i = 0; i < $(dlSearch).length; i++) {
      const dlName = $(dlSearch).eq(i).attr('name');
      const dlSearchData = dl_get_selected_input_items(dlName);
      if(dlSearchData.length === 0 || dlSearchData[0] === '') {
        continue;
      }
      for (var j = 0; j < $(dlList).length; j++) {
        const dlItemData = dl_get_setting_values_in_item($(dlList).eq(j), dlName);
        let check = dl_array_match_check(dlItemData, dlSearchData);
        if(!check) {
          $(dlList).eq(j).fadeOut('fast');
        }
      }
    }
  }
  function dl_get_selected_input_items(dlName) {
    const dlSearchData = [];
    $('select[name=' + dlName + '] option:selected').each(function() {
      dlSearchData.push($(this).val());
    });
    return dlSearchData;
  }
  function dl_get_setting_values_in_item(target, data) {
    const dlItemData = target.data(data);
    if(!Array.isArray(dlItemData)) {
      dlItemData = [dlItemData];
    }
    return dlItemData;
  }
  function dl_array_match_check(arr1, arr2) {
    let arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
});

//
// 「FAQ」絞り込み
//

$(function() {
  // カテゴリ絞り込み
  $(document).ready(function(){
    $(".faq_genre").find('input[name=genre]').on("change", change_select1);
  });
  function change_select1(){
    const valueCate = $('.faq_genre').find('input[name=genre]:checked').attr("value");
    const lengthProdOpt = $(".faq_cate option").length;
    for (var i = 1; i < lengthProdOpt; i++) {
      const opt1 = $(".faq_cate option").eq(i);
      const cls1 = opt1.attr("class");
      if (valueCate == cls1){
          opt1.fadeIn('fast');
      } else if (valueCate == "") {
          opt1.fadeIn('fast');
      } else {
          opt1.fadeOut('fast');
      }
    }
    const lengthListOpt = $(".faq_list li").length;
    for (var i = 0; i < lengthListOpt; i++) {
      const opt2 = $(".faq_list li").eq(i);
      const cls2 = opt2.data("genre");
      if (valueCate == cls2){
          opt2.fadeIn('fast');
      } else if (valueCate == "") {
          opt2.fadeIn('fast');
      } else {
          opt2.fadeOut('fast');
      }
    }

  }
  // 連動プルダウン絞り込み
  const dlSearch = '.faq_box';
  const dlList = '.faq_list_item';
  $(document).on('change', dlSearch, function() {
    search_filter_dl();
  });
  function search_filter_dl() {
    $(dlList).fadeIn('fast');
    for (var i = 0; i < $(dlSearch).length; i++) {
      const dlName = $(dlSearch).eq(i).attr('name');
      const dlSearchData = dl_get_selected_input_items(dlName);
      if(dlSearchData.length === 0 || dlSearchData[0] === '') {
        continue;
      }
      for (var j = 0; j < $(dlList).length; j++) {
        const dlItemData = dl_get_setting_values_in_item($(dlList).eq(j), dlName);
        let check = dl_array_match_check(dlItemData, dlSearchData);
        if(!check) {
          $(dlList).eq(j).fadeOut('fast');
        }
      }
    }
  }
  function dl_get_selected_input_items(dlName) {
    const dlSearchData = [];
    $('select[name=' + dlName + '] option:selected').each(function() {
      dlSearchData.push($(this).val());
    });
    return dlSearchData;
  }
  function dl_get_setting_values_in_item(target, data) {
    const dlItemData = target.data(data);
    if(!Array.isArray(dlItemData)) {
      dlItemData = [dlItemData];
    }
    return dlItemData;
  }
  function dl_array_match_check(arr1, arr2) {
    let arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
});

//
// 「インフォメーション」絞り込み
//

$(function() {
  // 年度絞り込み
  $(document).ready(function(){
    $(".news_ndown").find('input[name=year]').on("change", change_news);
  });
  function change_news(){
    const valueNewsCate = $('.news_ndown').find('input[name=year]:checked').attr("value");
    const lengthNewsListOpt = $(".news_index_list").length;
    for (var i = 0; i < lengthNewsListOpt; i++) {
      const newsOpt = $(".news_index_list").eq(i);
      const newsCls = newsOpt.data("cate");
      if (valueNewsCate == newsCls){
        newsOpt.fadeIn('fast');
      } else if (valueNewsCate == "") {
        newsOpt.fadeIn('fast');
      } else {
        newsOpt.fadeOut('fast');
      }
    }

  }
});

//////////////////////////////////////////////////////////////////
//
//  製品比較ページ - 項目表示制御
//
//////////////////////////////////////////////////////////////////

$(function(){
//ブロック1
  $('.compare_box1').change(function () {
    //選択したoptionのvalueを取得
    var val = $(this).val();
    //先頭に#を付けてvalueの値をidに変換
    var selectPhotoClass = '.' + val;
    //一度すべてのブロックを非表示にする
    $('.compare_list1 li').hide();
    //選択したブロックのみを表示
    $(selectPhotoClass).show();
    //シリーズ切替と同時に下層スペック表示リセット
    $('.specsize1 li:first-of-type').show();
  });
  // シリーズ下層スペック表示
  $('.size_box1').change(function () {
    var val = $(this).val();
    var sClass = '.' + val;
    $('.specsize1 li').hide();
    $(sClass).show();
  });

//ブロック2
  $('.compare_box2').change(function () {
    var val = $(this).val();
    var selectPhotoClass = '.' + val;
    $('.compare_list2 li').hide();
    $(selectPhotoClass).show();
    $('.specsize2 li:first-of-type').show();
  });
  $('.size_box2').change(function () {
    var val = $(this).val();
    var sClass = '.' + val;
    $('.specsize2 li').hide();
    $(sClass).show();
  });

//ブロック3
  $('.compare_box3').change(function () {
    var val = $(this).val();
    var selectPhotoClass = '.' + val;
    $('.compare_list3 li').hide();
    $(selectPhotoClass).show();
    $('.specsize3 li:first-of-type').show();
  });
  $('.size_box3').change(function () {
    var val = $(this).val();
    var sClass = '.' + val;
    $('.specsize3 li').hide();
    $(sClass).show();
  });
});

//////////////////////////////////////////////////////////////////
//
// お問い合わせフォーム - チェック/入力項目クリア
//
//////////////////////////////////////////////////////////////////

$(function() {
  const regi1 = $(".contact_newsletter").find('#regi1');
  //const regi2 = $(".contact_newsletter").find('#regi2');
  const mag  = $(".contact_newsletter").find('#mag2');
  // メルマガ「はい」選択時「登録済」チェック
  regi1.on('change', function() {
    if ($(this).prop('checked') == true) {
      $('#mag1, #mag2').prop('checked', false);
      $('#email2txt').val('');
      $('.mag_regi_sldup').slideUp('fast'); 
      //$('.mag_registered').prop('checked', true);
    }
  });
  // メルマガ「いいえ」選択時「登録済」チェック解除
  /*regi2.on('change', function() {
    if ($(this).prop('checked') == true) {
      $('.mag_registered').prop('checked', false);
    }
  });*/
  // メルマガ「希望しない」テキストある場合クリア
  mag.on('change', function() {
    if ($(this).prop('checked') == true) {
      $('#email2txt').val('');
      //$('.mag_registered').prop('checked', false);
    }
  });
});

//////////////////////////////////////////////////////////////////
//
// お問い合わせフォーム - 各所表示内容切替
//
//////////////////////////////////////////////////////////////////

$(function() {

  // お問い合わせ確認ページ表示内容切替
  $('.contact_form_others_result').val(function(){
    $(this).find('input[type=hidden]').not('.s_others, .s_all').remove();
    $(this).find('h2, span, section, div').not('.s_others').remove('.s_form, .s_pr');
  });
  $('.contact_form_index_result').val(function(){
    $(this).find('input[type=hidden]').not('.s_form, .s_all').remove();
    $(this).find('h2, span, section, div').not('.s_form').remove('.s_others, .s_pr');
  });
  $('.contact_form_pr_result').val(function(){
    $(this).find('input[type=hidden]').not('.s_pr, .s_all').remove();
    $(this).find('h2, span, section, div').not('.s_pr').remove('.s_others, .s_form');
  });
  $('.lang_jp').val(function(){
    $(this).find('.contact_country').remove();
  });
  $('.lang_en').val(function(){
    $(this).find('.contact_fax').remove();
  });
});

//////////////////////////////////////////////////////////////////
//
// お問い合わせフォーム - アコーディオン表示非表示
//
//////////////////////////////////////////////////////////////////

$(function() {
  // 業種・業態
    if ($.cookie('num7')) {
      num7 = $.cookie('num7');
      $('.sldtab7_cont').show();
    } else {
      num7 = 0;
      $('.sldtab7_cont').slideUp('fast');
    }
    tabSwitching7(num7);
    $('.sldtab7_cont').hide();
    $('.sldtab7_btn').click(function() {
      num7 = $('.sldtab7_btn').index(this);
      tabSwitching7(num7);
      $.cookie('num7', num7);
    });
    function tabSwitching7( num7 ){
      $('.sldtab7_cont').slideUp('fast');
      $('.sldtab7_cont').eq(num7).slideDown('fast');
    }
  // メルアド登録
    if ($.cookie('num12')) {
      num12 = $.cookie('num12');
      $('.sldtab12_cont').show();
    } else {
      num12 = 0;
      $('.sldtab12_cont').slideUp('fast');
    }
    $('.sldtab12_cont').hide();
    tabSwitching12(num12);
    $('.sldtab12_btn').click(function() {
      num12 = $('.sldtab12_btn').index(this);
      tabSwitching12(num12);
      $.cookie('num12', num12);
    });
    function tabSwitching12( num12 ){
      $('.sldtab12_cont').slideUp('fast');
      $('.sldtab12_cont').eq(num12).slideDown('fast');
    }
  });

//////////////////////////////////////////////////////////////////
//
// サイズ・モデルで探す - データ属性追加
//
//////////////////////////////////////////////////////////////////

$(function() {
  // LST
  const s_lst = $('#size_lst');
  s_lst.attr('data-size','["s4.3w","s5.7","s6.5","s7w","s8.4","s9w","s10.1w","s10.4","s12.1","s12.1w","s15","s15.6w","s18.5w","s19","s21.5"]');
  s_lst.attr('data-cate','RT');
  s_lst.attr('data-model','LST');
  // AST
  const s_ast = $('#size_ast');
  s_ast.attr('data-size','["s3.8","s4.7","s5.7","s6.2w","s6.5","s7.5","s7w","s8.4","s10.4","s10.5","s12.1","s15","s17.1","s19","s21.3"]');
  s_ast.attr('data-cate','RT');
  s_ast.attr('data-model','AST');
  // QST
  const s_qst = $('#size_qst');
  s_qst.attr('data-size','["s5.7","s7w","s8.4","s8.5w","s10.4","s12.1","s15"]');
  s_qst.attr('data-cate','RT');
  s_qst.attr('data-model','QST');
  // FST
  const s_fst = $('#size_fst');
  s_fst.attr('data-size','["s10.4","s12.1","s15","s17","s19"]');
  s_fst.attr('data-cate','RT');
  s_fst.attr('data-model','FST');
  // MTR-G
  const s_mtr_g = $('#size_mtr-g');
  s_mtr_g.attr('data-size','["s5.7","s7w","s8.4","s10.1w","s10.4","s12.1","s12.1w","s15","s15.6w","s18.5w","s21.5w"]');
  s_mtr_g.attr('data-cate','RT');
  s_mtr_g.attr('data-model','MTR-G');
  // DUS-A
  const s_dus_a = $('#size_dus-a');
  s_dus_a.attr('data-size','["s7w","s8.4","s10.1w","s10.4","s12.1","s12.1w","s13.3w","s15","s15.6w","s17","s18.5w","s19","s21.5w","s24w","s27w","s32w"]');
  s_dus_a.attr('data-cate','CT');
  s_dus_a.attr('data-model','DUS-A');
  // DUS-N
  const s_dus_n = $('#size_dus-n');
  s_dus_n.attr('data-size','["s8.4","s15"]');
  s_dus_n.attr('data-cate','CT');
  s_dus_n.attr('data-model','DUS-N');
  // DFS
  const s_dfs = $('#size_dfs');
  s_dfs.attr('data-size','["s15","s15.6w","s17","s18.5w","s19","s21.5w"]');
  s_dfs.attr('data-cate','CT');
  s_dfs.attr('data-model','DFS');
  // DFS
  const s_dus_xf = $('#size_dus-xf');
  s_dus_xf.attr('data-size','["s7w","s10.1w","s10.4","s12.1","s12.1w","s15","s15.6w","s18.5w","s21.5w"]');
  s_dus_xf.attr('data-cate','CT');
  s_dus_xf.attr('data-model','DUS-XF');
  // DUS-V
  const s_dus_v = $('#size_dus-v');
  s_dus_v.attr('data-size','["s4.3w","s7w","s10.1w"]');
  s_dus_v.attr('data-cate','CT');
  s_dus_v.attr('data-model','DUS-V');
  // DUS-M
  const s_dus_m = $('#size_dus-m');
  s_dus_m.attr('data-size','["s43w","s46w","s55w"]');
  s_dus_m.attr('data-cate','CT');
  s_dus_m.attr('data-model','DUS-M');
  // DUS-XM
  const s_dus_xm = $('#size_dus-xm');
  s_dus_xm.attr('data-size','["s43w","s46w","s55w"]');
  s_dus_xm.attr('data-cate','CT');
  s_dus_xm.attr('data-model','DUS-XM');
  // DUS-F
  const s_dus_f = $('#size_dus-f');
  s_dus_f.attr('data-size','["s7w","s10.1w","s10.4","s12.1","s15","s15.6w","s18.5w","s21.5w"]');
  s_dus_f.attr('data-cate','CGT');
  s_dus_f.attr('data-model','DUS-F');
  // DUS-LA
  const s_dus_la = $('#size_dus-la');
  s_dus_la.attr('data-size','["s7w","s10.1w","s10.4","s12.1","s15","s15.6w","s18.5w","s21.5w"]');
  s_dus_la.attr('data-cate','CGT');
  s_dus_la.attr('data-model','DUS-LA');
});

//////////////////////////////////////////////////////////////////
//
// 年数更新
//
//////////////////////////////////////////////////////////////////

var today = new Date();
$('.birth').each(function () {
  //年齢
  var birth = $(this).data('birth');
  var birthDate = new Date(birth);
  var age = today.getFullYear() - birthDate.getFullYear();
  var month = today.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  age = Math.max(age, 0);
  var value = age + '年';
  $(this).append(value);
});

//////////////////////////////////////////////////////////////////
//
// ドラッグでスクロール
//
//////////////////////////////////////////////////////////////////

jQuery.prototype.mousedragscrollable = function () {
  let target;
  let isDragging = false;
  const dragThreshold = 5; // ドラッグと判定する移動距離の閾値
  
  $(this).each(function (i, e) {
    let startX, startY;
    
    $(e).mousedown(function (event) {
      // 右クリックの場合は通常の動作を許可
      if (event.button === 2) return true;
      
      startX = event.clientX;
      startY = event.clientY;
      target = $(e);
      
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
    });

    $(e).click(function (event) {
      if (isDragging) {
        event.preventDefault();
        return false;
      }
    });
  });

  $(document).mousemove(function (event) {
    if ($(target).data("down")) {
      let currentX = event.clientX;
      let currentY = event.clientY;
      let initialX = $(target).data("x");
      let initialY = $(target).data("y");
      
      // 移動距離を計算
      let moveDistance = Math.sqrt(
        Math.pow(currentX - initialX, 2) + 
        Math.pow(currentY - initialY, 2)
      );
      
      // 閾値を超えた場合のみドラッグ処理を実行
      if (moveDistance > dragThreshold) {
        isDragging = true;
        event.preventDefault();
        
        let move_x = initialX - currentX;
        let move_y = initialY - currentY;
        
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    }
  });

  $(document).mouseup(function (event) {
    if ($(target).data("down")) {
      $(target).data("down", false);
      
      // マウスを離した時点でドラッグフラグをリセット
      setTimeout(() => {
        isDragging = false;
      }, 0);
    }
  });
};

// 使用例
$(".tscroll").mousedragscrollable();

//////////////////////////////////////////////////////////////////
//
// ヘッダー縦ビックメニュー
//
//////////////////////////////////////////////////////////////////

function menuShowDelay(elements, delayTime) { 
  var nowActive = -1;
  var hoverClass = 'gmenu-hover';
  
  elements.each(function(index) {
    var $element = $(this);
    var hoverTimer, leaveTimer;
    
    $element.on('mouseenter', function() {
      clearTimeout(leaveTimer);
      
      if (nowActive === -1) {
        hoverTimer = setTimeout(function() {
          $element.addClass(hoverClass);
          nowActive = index;
        }, delayTime);
      } else {
        if ($element.hasClass(hoverClass)) {
          clearTimeout(leaveTimer);
        } else {
          hoverTimer = setTimeout(function() {
            elements.removeClass(hoverClass);
            $element.addClass(hoverClass);
            nowActive = index;
          }, delayTime);
        }
      }
    });
    
    $element.on('mouseleave', function() {
      clearTimeout(hoverTimer);
      
      function mouseIsOverWorkaround(element) {
        var temp = $(element).parent().find(":hover");
        return temp.length === 1 && temp[0] === element;
      }
      
      if (mouseIsOverWorkaround(this)) {
        if ($element.hasClass(hoverClass)) {
          clearTimeout(hoverTimer);
        }
      } else {
        leaveTimer = setTimeout(function() {
          $element.removeClass(hoverClass);
          nowActive = -1;
        }, delayTime);
      }
    });
  });
}

$(function() {
  menuShowDelay($('.g-inner-navi2 > .g-inner-list'), 250);
});





document.addEventListener('DOMContentLoaded', function() {
  const pulldown1 = document.getElementById('pulldown1');
  const pulldown2Wrap = document.getElementById('pulldown2-wrap');
  const pulldown2 = document.getElementById('pulldown2');
  const pulldown2Options = pulldown2.innerHTML;

  // ページ読み込み時にストレージの状態を復元
  if (sessionStorage.getItem('pulldown1Value')) {
    pulldown1.value = sessionStorage.getItem('pulldown1Value');
    pulldown2.innerHTML = sessionStorage.getItem('pulldown2Options');
    pulldown2Wrap.style.display = sessionStorage.getItem('pulldown2Display');
  }

  pulldown1.addEventListener('change', function() {
    const selectedCategoryClass = this.options[this.selectedIndex].className;
    pulldown2.innerHTML = pulldown2Options;

    if (selectedCategoryClass === 'OTHER') {
      pulldown2Wrap.style.display = 'none';
    } else if (selectedCategoryClass) {
      pulldown2Wrap.style.display = 'block';
      const options = pulldown2.querySelectorAll('option');
      options.forEach(option => {
        if (option.value && !option.classList.contains(selectedCategoryClass)) {
          option.remove();
        }
      });
    } else {
      pulldown2Wrap.style.display = 'none';
    }

    // ストレージに現在の状態を保存
    sessionStorage.setItem('pulldown1Value', this.value);
    sessionStorage.setItem('pulldown2Options', pulldown2.innerHTML);
    sessionStorage.setItem('pulldown2Display', pulldown2Wrap.style.display);
  });
});